import { render } from "./CommandEvent.vue?vue&type=template&id=421bcf27"
import script from "./CommandEvent.vue?vue&type=script&lang=js"
export * from "./CommandEvent.vue?vue&type=script&lang=js"

import "./CommandEvent.vue?vue&type=style&index=0&id=421bcf27&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__